import React from 'react';
import styles from './TableSelector.module.scss';
import clsx from 'clsx';

const Table = (props) => {
    const { attributes, children, element } = props;

    return (
        <table className={clsx(styles.EditorTable, { [styles.CustomTable]: !!props?.element?.custom })}>
            <tbody {...attributes}>{children}</tbody>
        </table>
    );
};

export default Table;
